export class StringUtility {
	public static isGuid(text?: string): boolean {
		if (!text)
			return false;

		const isGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
		return text.match(isGuid) !== null;
	}

	public static escapeODataFilterString(term: string): string {
		return term.replace(/'/g, "''");
	}

}
